import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import newchannelmapping from '../newchannelmapping'
import { BasicSelect } from 'vue-search-select'
export default {
  name: 'client',
  components: {
    Pagination,
    Loader,
    newchannelmapping,
    BasicSelect


  },
  data: function () {

    return {
      Chanelsearch: '',
      listfilterChannelData: [],
      filterstatus: '',
      currentPage: 1,
      totalPage: 0,
      totalCount: 0,
      pageLimit: 10,
      showSelectWarehouse: false,
      modalShow: false,
      listChannelData: [],
      WarehouseErr: '',
      showSelectClient: false,
      isLoading: false,
      is_Loading: false,
      resultCount: '',
      listClientData: [],
      listWarehouseData: [],
      changestatus: '',
      ClientErr: '',
      WarehouseErr: '',
      editModal: false,
      clientid: '',
      warehouseid:'',
      showChannelList: true,
      selectedRowData: {
        id: '',
        warehouseid: '',
        warehousename:'',
        saleschannel: '',
        channelname: '',
        uniwarewarehouse: '',
        clienttoken: '',
        status: '',
        tokencreateddate:'',
        thirdpartyshipping: '',
        specialpackinginstruction:'',
      },
      channelErrors: {},
      clientItem: {},
      warehouseItem: {},
      editWarehouseItem: {
        'value':'',
        'text':''
      },
      salesChannelItem: {},
      editSalesChannelItem: {
        'value':'',
        'text':''
      },
      expiryDate: '',
      isClientTokenExpired: false,
    }
  },
  created: function () { },
  filters: {
    moment: function (date) {
      if (!date) return '';
      return moment(date).format('DD-MM-YY HH:mm:ss');
    }
  },

  mounted() {
    this.pageno = 0
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail.email;

    this.user_type = userdetail.utype;
    this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
    if(this.clientid!=='undefined'){
      this.getChannelList()
    }
    switch (this.user_type) {
      case 'system_user':
        this.showSelectClient = true;
        this.showSelectWarehouse = true;
        // this.getClientList();
        // this.getWarehouseList();
        break;

      case 'client_user':
        this.clientid = userdetail.clientid;
        // this.getClientList();
        // this.getWarehouseList();
        this.showSelectWarehouse = true;
        break;

      case 'warehouse_user':
        this.warehouseid = userdetail.warehouseid;
        this.showSelectClient = true;
        // this.getClientList();
        break;

      default:
        this.$alertify.error("Unauthorised user, Please contact your system admin");
        break
    }
  },
  methods: {
    // getClientList() {
    //   this.pageNo = this.totalPage = 0;
    //   if (window.localStorage.getItem("clientList") !== null) {
    //     var clientListEncrypt = window.localStorage.getItem('clientList');
    //     var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
    //     var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
    //     this.getClientSelectOptions(JSON.parse(plaintextclient));
    //   } else {
    //     var userToken = window.localStorage.getItem('userToken');
    //     var myStr = userToken.replace(/"/g, '');
    //     axios({
    //       method: 'POST',
    //       'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
    //       'data': {},
    //       headers: {
    //         'Authorization': 'Bearer ' + myStr,
    //       }
    //     })
    //       .then(result => {
    //         this.getClientSelectOptions(result.data.data)
    //       }, error => {
    //         console.error(error);
    //       });
    //   }
    // },
    // async getWarehouseList() {
    //   if (window.localStorage.getItem("warehouseList") !== null) {
    //     var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
    //     var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
    //     var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
    //     this.getWarehouseSelectOptions(JSON.parse(plaintextwarehouse));
    //   } else {
    //     var userToken = window.localStorage.getItem('userToken')
    //     var myStr = userToken.replace(/"/g, '');
    //     this.pageno = 0;
    //     this.input = ({
    //       clientid: this.clientid,
    //     });

    //    await axios({
    //       method: 'POST',
    //       'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
    //       'data': this.input,
    //       headers: {
    //         'Authorization': 'Bearer ' + myStr
    //       }
    //     })
    //       .then(result => {
    //         this.getWarehouseSelectOptions(result.data.data);
    //       }, error => {
    //         console.error(error)
    //       })
    //   }
    // },
    // clientSelected(item) {
    //   this.clientItem = item;
    //   if (this.clientid != this.clientItem.value) {
    //     this.clientid = this.clientItem.value;
    //     this.Chanelsearch = '';
    //     this.salesChannelItem={};
    //     this.getChannelList();
    //     if (this.user_type != 'warehouse_user') {
    //       this.listWarehouseData = []
    //       this.warehouseid='';
    //       this.warehouseItem={};
    //       this.getWarehouseList();
    //     }
    //   }
    //   this.pageno = this.totalPage = 0;
    // },
    // warehouseSelected(item) {
    //   this.warehouseItem = item;
    //   this.warehouseid = item.value;
    //   this.pageno = this.totalPage = 0;
    //   if (this.warehouseid) {
    //     if (this.clientid) {
    //     } else {
    //       this.getClientList();
    //     }
    //   }
    // },
    getChannelList() {
      this.pageNo = this.totalPage = 0;
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        clientid: this.clientid,
      })
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'orderSalesChannelList',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr,
        }
      })
        .then(result => {
          this.getSalesChannelSelectOptions(result.data.data);
        }, error => {
          console.error(error);
        });
    },
    closeEditModal() {
      this.editModal = false
    },
    getBinSearch() {
      if (window.localStorage.getItem('selectedClient')==='undefined' ) {
        this.$alertify.error(this.$t('common.clientError'))
        this.pageNo = this.totalPage = 0;
        return;
      }
      if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
        this.$alertify.error(this.$t('common.warehouseError'))
        this.pageNo = this.totalPage = 0;
        return;
      }
      this.currentPage = 1;
      this.getChannelData();
    },
    getChannelData() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var offset = (this.currentPage - 1) * 10
      var limit = 10
      this.input = ({
        offset: offset.toString(),
        limit: limit.toString(),
        saleschannel: this.Chanelsearch,
        clientid: window.localStorage.getItem('selectedClient'),
        warehouseid: window.localStorage.getItem('selectedWarehouse'),
        status: this.filterstatus,
      })
      this.isLoading = true;
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getChannelMappingData',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then(result => {
          if (result.data.data[0].ErrorCode == -1) {
            this.listChannelData = [];
            this.resultCount = 0;
            this.totalRows = 0;
            this.$alertify.error(result.data.data[0].msg);
          } else {
            this.listChannelData = result.data.data[0].data.data;
            if (this.listChannelData.length == 0) {
              this.$alertify.error(result.data.data[0].msg);
            } else {
              this.$alertify.success(result.data.data[0].msg);
            }
            this.totalRows = result.data.data[0].data.count;
            this.resultCount = result.data.data[0].data.count;
            if (this.totalRows <= this.pageLimit) {
              this.totalPage = 1;
            } else {
              this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
            }
          }
          this.isLoading = false;
        }, error => {
          console.error(error)
        })
    },
    getSelectedRowData(data) {
      this.expiryDate = this.getExpirydays(data.tokencreateddate);
      this.selectedRowData.id = data.id;
      this.selectedRowData.warehouseid = data.warehouseid;
      this.selectedRowData.warehousename = data.warehousename;
      this.selectedRowData.saleschannel = data.saleschannel;
      this.selectedRowData.channelname = data.channelname;
      this.selectedRowData.uniwarewarehouse = data.rubiconwarehousename;
      this.selectedRowData.clienttoken = data.clienttoken;
      this.selectedRowData.status = data.status;
      this.selectedRowData.tokencreateddate=data.tokencreateddate;
      this.selectedRowData.thirdpartyshipping=data.thirdpartyshipping;
      this.selectedRowData.specialpackinginstruction = data.sendlabel;
      this.editWarehouseItem.value=data.warehouseid;
      this.editWarehouseItem.text=data.warehousename;
      this.editSalesChannelItem.value=data.saleschannel;
      this.editSalesChannelItem.text=data.saleschannel;
      this.editModal = true;
      console.log(this.editWarehouseItem)
    },
    getStatusRowData(data) {
      this.modalShow = true
      this.selectedRowData.id = data.id;
      this.selectedRowData.warehouseid = data.warehouseid;
      this.selectedRowData.warehousename = data.warehousename;
      this.selectedRowData.saleschannel = data.saleschannel;
      this.selectedRowData.channelname = data.channelname;
      this.selectedRowData.uniwarewarehouse = data.rubiconwarehousename;
      this.selectedRowData.clienttoken = data.clienttoken;
      this.selectedRowData.status = data.status;
      this.selectedRowData.tokencreateddate=data.tokencreateddate;
      this.selectedRowData.thirdpartyshipping=data.thirdpartyshipping;
      this.selectedRowData.specialpackinginstruction = data.sendlabel;
      if (data.status == '0') {
        this.changestatus = 'activate'
      } else {
        this.changestatus = 'deactivate'
      }
    },
    changeClientStatus() {
      this.selectedRowData.status = 1 - this.selectedRowData.status;
      this.modalShow = false;
      this.updateChannelData();
    },
    closeStatusClientModal() {
      this.modalShow = false;
    },
    onEditSubmit() {
      if (this.onEditFormCheck()) {
        console.log('jjjjj');
        this.editModal = false;
        this.updateChannelData();
      }
    },
    updateChannelData() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      let input = {
        'id': this.selectedRowData.id,
        'warehouseid': this.selectedRowData.warehouseid,
        'channelname': this.selectedRowData.channelname.trim(),
        'status': this.selectedRowData.status,
        'saleschannel': this.selectedRowData.saleschannel,
        'createdby': this.useremail,
        'clienttoken': this.selectedRowData.clienttoken,
        'warehousename': this.selectedRowData.warehousename,
        'uniwarewarehouse': this.selectedRowData.uniwarewarehouse.trim(),
        'thirdpartyshipping': this.selectedRowData.thirdpartyshipping,
        'specialpackinginstruction':this.selectedRowData.specialpackinginstruction,
      }
      if(this.selectedRowData.tokencreateddate){
        input.tokencreateddate = this.selectedRowData.tokencreateddate;
      }
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'updateChannelMappingData',
        'data': input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then((response) => {
          if (response.data.data[0].ErrorCode != -1) {
            this.$alertify.success("Channel data update successfully")
          } else {
            this.$alertify.error("Channel data update failed")
          }
          this.getChannelData();
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })

    },
    resetForm() {
      this.Chanelsearch = '';
      this.salesChannelItem={};
      this.resultCount = 0;
      this.listChannelData = [];
      // this.listfilterChannelData=[];
      this.filterstatus = '';
      if (this.user_type == 'warehouse_user') {
        this.clientid = '';
        this.clientItem={}
      }
      else if (this.user_type == 'client_user') {
        this.warehouseid = '';
        this.warehouseItem={};
      }
      else {
        this.clientid = '';
        this.clientItem={};
        this.warehouseid = '';
        this.warehouseItem={};
      }
    },

    onPageChange(page) {
      this.currentPage = page;
      this.getChannelData()
    },
    addNewChannel() {
      this.showChannelList = false;
    },
    async callParent(clientItem, warehouseItem) {
      this.showChannelList = true;
      if (clientItem.value && warehouseItem.value) {
        this.clientItem=clientItem;
        this.clientid = this.client = clientItem.value;
      await this.getWarehouseList()
        this.warehouseItem=warehouseItem;
        this.warehouseid = this.warehouseItem.value;
        this.getBinSearch();
      }
    },
    onEditFormCheck() {
      this.channelErrors = {};
      if (!this.selectedRowData.warehouseid)
        this.channelErrors.warehouseid = this.$t('purchaseOrder.shipWarehouse');
      if (!this.selectedRowData.channelname.trim())
        this.channelErrors.channelname = this.$t('unicommerce.channelmapping.channelNameErr');
      if (!this.selectedRowData.saleschannel)
        this.channelErrors.saleschannel = this.$t('unicommerce.channelmapping.saleChannelErr');
      if (!this.selectedRowData.uniwarewarehouse.trim())
        this.channelErrors.uniwarewarehouse = this.$t('unicommerce.channelmapping.uniwareWarehouseErr');
      if (!this.selectedRowData.thirdpartyshipping)
        this.channelErrors.thirdpartyshipping = this.$t('unicommerce.channelmapping.thirdPartyShippingErr');
      if(!this.selectedRowData.specialpackinginstruction)
          this.channelErrors.specialpackinginstruction = this.$t('unicommerce.channelmapping.specialpackinginstructionErr');
      if (!this.selectedRowData.clienttoken.trim())
        this.channelErrors.clienttoken = this.$t('unicommerce.channelmapping.clientTokenErr');
       if (Object.keys(this.channelErrors).length == 0) {
        return true;
      } else {
        return false;
      }
    },
    getClientToken() {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      return axios({
        method: 'POST',
        'url': apiUrl.api_url + 'generateClientToken',
        'data': { "clientid": this.clientid },
        headers: {
          'Authorization': 'Bearer ' + myStr,
        }
      })
        .then(result => {
          this.selectedRowData.clienttoken = result.data.token;
          this.selectedRowData.tokencreateddate = moment(new Date()).format('YYYY-MM-DD');
          this.$alertify.success("Client token fetched")
        }, error => {
          console.error(error);
        });
    },
    getSelectOptions(result, value, text) {
      var data = [];
      result.forEach(ele => {
        data.push({
          "value": ele[value],
          "text": ele[text]
        })
      })
      return data;
    },
    salesChannelSelected(item) {
      this.salesChannelItem = item;
      this.Chanelsearch = item.value;
    },
    getExpirydays(date) {
      let currentdate = new Date().getTime();
      let createdDate = new Date(date).getTime();
      let diff = Math.ceil((currentdate - createdDate) / (1000 * 3600 * 24))
      this.isClientTokenExpired = (365 - diff) < 0 ;

      return 365 - diff;
    },
    onEditWarehouseSelected(item){
      this.editWarehouseItem=item;
      this.selectedRowData.warehouseid=item.value;
      this.selectedRowData.warehousename=item.text;
    },
    onEditSalesChannelSelected(item){
      this.editSalesChannelItem=item;
      this.selectedRowData.saleschannel=item.text;
    },
    getClientSelectOptions(data){
        this.clientItem = {
            value: '',
            text: ''
        };
        this.listClientData = [{
            value: '',
            text: this.$t('common.clientPlaceholder')
        }];
        data.forEach(ele => {
            this.listClientData.push({
                "value": ele.clientid,
                "text": ele.clientname
            })
        })
    },
    getWarehouseSelectOptions(data){
        this.warehouseItem = {};
        this.listWarehouseData = [{
            value: '',
            text: this.$t('common.warehousePlaceholder')
        }];
        data.forEach(ele => {
            this.listWarehouseData.push({
                "value": ele.warehouseid,
                "text": ele.warehousename
            })
        })
    },
    getSalesChannelSelectOptions(data){
        this.salesChannelItem = {
            value: '',
            text: ''
        };
        this.listfilterChannelData = [{
            value: '',
            text: this.$t('orders.salesChannelPlaceHolder')
        }];
        data.forEach(ele => {
            this.listfilterChannelData.push({
                "value": ele.saleschannel,
                "text": ele.saleschannel
            })
        })
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/components/uniware/channelmapping/channelmapping.component.js